import { UserAiUsageDay } from "./admin.api";

/** What the admin cards say about a user's recent AI usage. */
export interface AiUsageSummary {
  busiestDate: string | null;
  activeDays: number;
  averageDailyCost: number;
}

/**
 * Summarises a user's daily AI usage for the admin cards.
 *
 * Days without requests are absent from the gateway's answer rather
 * than present with zeroes, so the average is over days the user was
 * actually active — which is the number an admin is looking for when
 * judging whether a user is expensive.
 */
export function summarizeAiUsage(usage: UserAiUsageDay[]): AiUsageSummary {
  if (usage.length === 0) {
    return { busiestDate: null, activeDays: 0, averageDailyCost: 0 };
  }

  const busiest = usage.reduce((top, day) => (day.cost > top.cost ? day : top));
  const total = usage.reduce((sum, day) => sum + day.cost, 0);

  return {
    busiestDate: busiest.date,
    activeDays: usage.length,
    averageDailyCost: total / usage.length,
  };
}
